// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__xqUxT","thumb":"switch_thumb__xC8XL","checked":"switch_checked__6DdB6"};